<svg
  [attr.width]="width ?? size"
  [attr.height]="height ?? size"
  viewBox="0 0 19 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15.0423 9.49992H3.95898M3.95898 9.49992L9.50065 15.0416M3.95898 9.49992L9.50065 3.95825"
    stroke="#A0A0A0"
    stroke-width="1.58333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
